module.exports = __webpack_public_path__ + "img/settings-select.9e280b94.svg";